import { render, staticRenderFns } from "./NuovoFamiliare.vue?vue&type=template&id=0550e51e&"
import script from "./NuovoFamiliare.vue?vue&type=script&lang=js&"
export * from "./NuovoFamiliare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports